import { GalleryType } from "@enums/galleryType";
import { IFileForUpload } from "@interfaces/Shared/file";
import { IFormValues } from "@interfaces/Shared/formValues";
import { ICreateMedia } from "@interfaces/createMedia";
import { ICreateMediaItem } from "@interfaces/createMediaItem";
import getMedia from "@services/Media/getMedia";
import { TCreateMediaDto } from "types/Media/createMediaDto";
import { getCapitalizedFirstChar } from "./string";

export const apiMediaToDto = ({
  title,
  date,
  type,
  gallery,
}: ICreateMedia): TCreateMediaDto => ({
  title,
  date,
  type: getCapitalizedFirstChar(type),
  gallery: gallery.map((item) => ({
    ...item,
    name: item.name ?? undefined,
    caption: item.caption ?? undefined,
    thumbnailUrl: item.thumbnailUrl ?? undefined,
    width: item.width ?? undefined,
    height: item.height ?? undefined,
  })),
});

export const galleryTypeOptions = [
  {
    value: GalleryType.Single,
    label: getCapitalizedFirstChar(GalleryType.Single),
  },
  {
    value: GalleryType.Carousel,
    label: getCapitalizedFirstChar(GalleryType.Carousel),
  },
  {
    value: GalleryType.Gallery,
    label: getCapitalizedFirstChar(GalleryType.Gallery),
  },
];

export const removeFileFromFileList = (
  fileList: FileList,
  fileToRemove: File
): FileList => {
  const dataTransfer = new DataTransfer();

  Array.from(fileList).forEach((file) => {
    if (file !== fileToRemove) {
      dataTransfer.items.add(file);
    }
  });

  return dataTransfer.files;
};

export const getFullGalleryForUpdate = async (
  formValuesForUpdate: IFormValues,
  isMultipleFilesUpload: boolean,
  filesForUpload: IFileForUpload[],
  uuid: string
): Promise<IFormValues> => {
  if (isMultipleFilesUpload && filesForUpload.length > 0) {
    const savedFormValuesWithGallery = await getMedia(uuid).then(
      (response) => response.data
    );

    // Create full gallery with previously uploaded media and new media
    const fullGallery = savedFormValuesWithGallery.gallery.concat(
      formValuesForUpdate.gallery as ICreateMediaItem[]
    );

    formValuesForUpdate.gallery = fullGallery;

    // Remove deleted items from array
    return filterDeletedItemsFromGallery(formValuesForUpdate);
  } else {
    return filterDeletedItemsFromGallery(formValuesForUpdate);
  }
};

export const filterDeletedItemsFromGallery = (
  formValues: IFormValues
): IFormValues => {
  if (!formValues.gallery) {
    formValues.gallery = [];
    return formValues;
  }

  if (!formValues.galleryFilesForDelete) {
    return formValues;
  }

  const uuidsToRemove = (
    formValues.galleryFilesForDelete as ICreateMediaItem[]
  ).map((item) => item.uuid);

  return {
    ...formValues,
    gallery: (formValues.gallery as ICreateMediaItem[]).filter(
      (item) => !uuidsToRemove.includes(item.uuid)
    ),
  };
};
